


import { createSlice } from '@reduxjs/toolkit'

export const totalDeudaSlice = createSlice({
    name: 'totalDeudaStore',
    initialState: {
        value: 0
    },
    reducers: {
        addTotalDeuda: (state, action) => {
            state.value = action.payload
        }
    }
})

// Action creators are generated for each case reducer function
export const { addTotalDeuda } = totalDeudaSlice.actions

export default totalDeudaSlice.reducer